<template>
  <div class="myself_wrapper">
    <el-dialog :title="$t('other.a3206')" :visible.sync="publishFailedDia" :close-on-click-modal="false" width="50%">
      <div style="diplay:flex;margin-bottom:20px;">
        <span class="jkgiong">
          <span class="ifnk"></span>
          <span>{{ $t('other.a3099') }}</span>
        </span>
        <span class="jkgiong">
          <span class="ifnkCopy"></span>
          <span>{{ $t('other.a3210') }}</span>
        </span>
      </div>
      <div>
        <el-table :data="publishFailed" size="mini" border>
          <el-table-column :label="$t('other.a3207')">
            <template slot-scope="props">
              <span>{{ showShopName(props.row.productShops[0].shopId) }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('other.a3208')">
            <template slot-scope="props">
              <span>{{ props.row.productShops[0].createTime }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('other.a68')">
            <template slot-scope="props">
              <span>{{ props.row.items.length > 0 ? props.row.items[0].itemId : $t('other.a140') }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('other.a3209')">
            <template slot-scope="props">
              <span class="ifnk" v-show="props.row.productShops[0].publishNum > 0"></span>
              <span class="ifnkCopy" v-show="!props.row.productShops[0].publishNum"></span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('other.a33')" width="280px">
            <template slot-scope="props">
              <!-- <span style="margin:0 2px" v-if="props.row.productShops[0].publishNum > 0"><el-button size="mini" :type="!props.row.default ? 'primary': 'danger'"  @click="publishAgine(props.row)">{{$t('other.a1278')}}</el-button></span> -->
              <span style="margin:0 2px" v-if="props.row.productShops[0].publishNum == 0">
                <el-button size="mini" :type="!props.row.default ? 'primary' : 'danger'"
                  @click="publishAgine(props.row)">{{ $t('other.a3211') }}</el-button>
              </span>
              <!-- <span style="margin:0 2px"><el-button size="mini" :type="!props.row.default ? 'primary': 'danger'"  @click="discontinuedProduct(props.row)">下架产品</el-button></span> -->
              <span style="margin:0 2px">
                <el-button size="mini" type="info" @click="deleItem(props.row, props.$index)">{{ $t('other.a273')
                }}</el-button>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="publishFailedDia = false">{{ $t('other.a5') }}</el-button>
      </span>
    </el-dialog>


    <el-dialog title="批量上架产品至TEMU" :visible.sync="isUpload" width="90%">
      <div class="stepsBox">
        <div class="stepsItem">
          <div class="stepsIndex">
            1
          </div>
          <div class="stepsTitle">
            下载导入模板
          </div>
          <div class="stepsContent">
            <el-button type="text" @click="isUpload = false">点击 下载批量上架产品 到TEMU后台的模板</el-button>
          </div>
        </div>
        <div class="stepsItem">
          <div class="stepsIndex">
            2
          </div>
          <div class="stepsTitle">
            导入上架产品文件
          </div>
          <div class="stepsContent">
            <div class="tips">
              1、本模板只适用于非服装类目，目前只开放 浴室防滑垫；沙滩毛巾；小盖毯、午休毯；以上三个类目。<br>
              2、货品类目与属性模板存在对应关系，需按照对应的模板规则填写。<br>
              3、产品标题长度校验：{ A.长度限制100[cat1Id=1(CD和黑胶唱片)] B.长度限制200[cat1Id=653(办公用品)，cat1Id=25439(玩具与游戏)]
              C.长度限制500[cat1Id=2542(电子)] D.除去以上4个分类,其他长度限制250}。<br>
              4、产品分类：A.浴室防滑垫[11802] B.沙滩毛巾[11809] C小盖毯、午休毯[11901] 请复制以上分类填写。
            </div>
            <el-upload class="upload-demo" ref="uploadTEMURef" action="#" :limit="1" :http-request="uploadTEMU"
              :before-upload="beforeUpload" :on-remove="handleRemove">
              <el-button slot="trigger" size="small" type="primary" style="margin-top: 20px;">{{ $t('other.a368') }}</el-button>
              <el-button style="margin-left: 10px;background: #ff8000;border-color: #ff8000;" size="small" type="success"
                @click.stop="submitUpload">{{ $t('other.a3385') }}</el-button>
            </el-upload>
            <div style="margin-top: 20px;">
              <span class="tips">[重要提示!!!]请确保您上传的表格数据准确无误。</span>批量上架表格提交后，系统将自动处理且无法中断或撤销。<span class="tips">请务必仔细检查表格内容,
                确认无误后再提交，以避免因数据错误导致的损失。</span>平台对因数据不准确或操作失误造成的后果不承担责任。
            </div>
          </div>
        </div>
      </div>
      <div class="recordBox">
        <div class="recordTitle">
          {{ $t('other.a3386') }}
        </div>
        <el-table :data="recordData" border style="width: 100%">
          <el-table-column prop="fileName" :label="$t('other.a3387')">
          </el-table-column>
          <el-table-column prop="totalRecords" label="文件总数">
          </el-table-column>
          <el-table-column prop="taskStatus" label="状态">
            <template slot-scope="scope">
              <div>
                {{ scope.row.taskStatus == 0 ? '待执行' : scope.row.taskStatus == 1 ? '执行中' :
                  scope.row.taskStatus ==
                    2 ? '已执行' : scope.row.taskStatus == 3 ? '已删除' : '已停止' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="process" label="执行进度">
            <template slot-scope="scope">
              <div>
                {{ scope.row.process }}%
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="successRecords" label="上架成功数">
          </el-table-column>
          <el-table-column prop="failedMessage" label="上架失败记录">
          </el-table-column>
          <el-table-column prop="createdTime" label="创建时间">
            <template slot-scope="scope">
              <div>
                {{ formatISODateToFull(scope.row.createdTime) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="startTime" label="开始时间">
            <template slot-scope="scope">
              <div>
                {{ formatISODateToFull(scope.row.startTime) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="endTime" label="结束时间">
            <template slot-scope="scope">
              <div>
                {{ formatISODateToFull(scope.row.endTime) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.taskStatus == 1" size="mini" type="warning"
                @click="handleStop(scope.$index, scope.row)">停止</el-button>
              <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align:right">
          <el-pagination @size-change="handleSizeRecordChange" @current-change="handleCurrentRecordChange"
            :current-page="getRecordDataList.pageNum" :page-sizes="[15, 20, 30, 50]"
            :page-size="getRecordDataList.pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="getRecordDataList.total">
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="isUpload = false">关 闭</el-button>
      </span>
    </el-dialog>


    <div class="header_top">
      <div class="ijkgn">{{ $t('other.a1781') }}</div>
      <!-- 一级菜单栏 -->
      <div class="query_list">
        <span :class="{ item_wrapper: true, item_active: item.value == warehouseId }" v-for="(item, index) in storeList"
          :key="index" @click="getStoreItemAndGroup(item)">
          <span v-if="item.imgUrl" style="display:inline-block;width:20px;height:20px;overflow:hidden">
            <img style="width:100%" :src="item.imgUrl" />
          </span>
          {{ item.label }}
        </span>
      </div>
      <!-- 二级菜单栏 -->
      <div class="query-list-tcp">
        <div class="query-list-bbc">
          <el-input style="width: 320px; margin: 0 5px" clearable :placeholder="$t('distribution.searchStore')"
            v-model="dataParams.cusCode"></el-input>
          <el-button type="primary" @click="searchProduct()">
            {{
              $t("userStoreItems").search
            }}
          </el-button>
          <el-button type="primary" @click="openIsUpload">批量上架至TEMU</el-button>
        </div>

        <div style="margin-right:30px">
          <!-- <el-checkbox style="margin: 0 15px 0 0" v-model="checkedAll"
              ><span style="font-size: 18px"
                > ({{ targetList.length }})</span
              ></el-checkbox
          >-->

          <span style="margin-left:15px">
            <el-button type="primary" v-if="!isShopsooo" @click="massDeletd()">{{ $t('distribution.operationBatchDelete')
            }}</el-button>
          </span>
          <span style="margin-left:15px">
            <el-button type="primary" v-if="!isShopsooo" @click="massPublishTik()">{{ $t('other.a3212') }}</el-button>
          </span>
          <span style="margin-left:15px">
            <el-button type="primary" v-if="!isShopsooo" @click="toOpen()">{{ $t('other.a3213') }}</el-button>
          </span>
          <span style="margin-left:15px">
            <el-button type="info" @click="openGuid()">{{ $t('other.a3214') }}</el-button>
          </span>
        </div>
      </div>
    </div>
    <!-- 产品展示列表 -->
    <div class="overseaProduct_list">
      <div :class="{ 'overseaProduct_item': true, 'overseaProduct_item_active': activeIndex === index }"
        @mouseenter="activeIndex = index" @mouseleave="activeIndex = -1" v-for="(item, index) in overDataList"
        :key="index">
        <div style="margin:5px ">
          <el-checkbox v-model="item.checked" @change="chooseItem(item, index)"></el-checkbox>
        </div>
        <div class="pic_box" @click="toDetail(item)">
          <span class="offshelf" v-if="item.allOffShelf">
            <div>{{ $t('other.a3205') }}</div>
            <div>{{ $t('other.a1083') }}</div>
          </span>
          <span class="offshelf" v-if="!item.allOffShelf && item.offShelfList.length > 0">
            <div>{{ $t('other.a3205') }}</div>
            <div>{{ $t('other.a3215') }}</div>
          </span>
          <img style="width:100%" :src="item.image ? item.image : item.storeItems[0].image" />
        </div>
        <div class="title_overseaProduct">{{ item.groupName }}</div>
        <div class="item_desc_parentsku">{{ $t('distribution.mSKU') }}：{{ item.itemSku }}</div>
        <div class="item_desc">{{ $t('distribution.sSKUNum') }}：{{ item.storeItems.length }}</div>
        <div class="item_desc">{{ $t('distribution.totalStock') }}：{{ item.total }}</div>
        <div class="update_overseaProduct">
          <span class="bitbn" @click="getRecord(item)">{{ $t('other.a3206') }}</span>
          <!-- <span class="btn"  @click="updataItem(item)">{{$t('distribution.releaseProduct')}}</span> -->
          <el-dropdown>
            <el-button size="mini" type="primary">{{ $t('other.a3216') }}</el-button>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item @click.native="updataItem(item)">发布shopee产品oo</el-dropdown-item> -->
              <el-dropdown-item @click.native="publish(item, 4)">发布TEMU产品</el-dropdown-item>
              <el-dropdown-item @click.native="publish(item, 1)">{{ $t('other.a321') }}</el-dropdown-item>
              <el-dropdown-item @click.native="publish(item, 2)">{{ $t('other.a336') }}</el-dropdown-item>
              <el-dropdown-item @click.native="publish(item, 3)">{{ $t('other.a2887') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <div class="Pager">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10, 15, 20, 50, 100]" :page-size="dataParams.offset"
        layout="total, sizes, prev, pager, next, jumper" :total="overDataTotal"></el-pagination>
    </div>
  </div>
</template>

<script>
import TableDialog from "./../components/table.vue";
import userStoreItemsApi from "../../../api/moudles/userStoreItems";
import QrcodeDialog from "../../../components/dialog/qrcodeDialog";
import utils from "../../../utils/utils";
import galleryApi from '@/api/moudles/gallery'
import { mapState, mapActions, mapMutations } from "vuex";
import config from "../config/config";
import api from "../../../api/api";
export default {
  data() {
    return {
      isShopsooo: JSON.parse(localStorage.getItem("isShopsooo")),
      openDialog: false,
      warehouseId: "all",
      activeIndex: -1,
      TitleDesc: "",
      mainProductId: null,
      handleParam: null,
      cusCode: "",
      newUserstoreItem: [],
      publishFailed: [],
      offset: 15,
      instockdia: false,
      getDataList: null,
      page: 0,
      checkedAll: false,
      publishFailedDia: false,
      targetList: [],
      isExtened: false,
      isEdit: -1,
      dialogTableVisibleTwo: false,
      additionParents: [],
      isShow: false,
      isAlliance: false,
      isEditGoods: false,
      multipleSelection: [],
      additionItem: null,
      storeList: [],
      listErrorOptions: [],
      itemsCount: 0,
      tableList: [],
      tableCount: 0,
      currentPage4: 1,
      currentPage: 1,
      page: 0,
      value: null,
      dataParams: {
        component: false,
        distribution: true,
        cusCode: "",
        offset: 50,
        page: 0,
        sellerId: JSON.parse(localStorage.getItem("userInfo")).userId,
        storeId: null,
        userId: JSON.parse(localStorage.getItem("userInfo")).userId
      },
      overDataList: [],
      overDataTotal: 0,
      isUpload: false,
      fileData: null,
      recordData: [],
      exportStatus:true,
      getRecordDataList: {
        pageSize: 20,
        pageNum: 1,
        total: 0
      },
    };
  },
  computed: {
    ...mapState({
      userId: state => state.shopaccess.userInfo.userId,
      userName: state => state.shopaccess.userInfo.userName
    }),
    targetListCopy() {
      let num = 0;
      let list = this.targetList.filter(p => {
        if (p.checked) {
          num++;
          return p;
        }
      });
      if (list.length == [] && num == 0) {
        this.targetList = [];
        num = 0;
      }
      return list;
    },
    cusCodeValue() {
      return JSON.parse(JSON.stringify(this.dataParams.cusCode));
    }
  },

  watch: {
    // storeList: function (val) {
    //     console.log('112541',val);
    // },
    cusCodeValue() {
      if (!this.cusCodeValue) {
        this.getdistrubureData(this.dataParams);
      }
    }
  },
  components: {},
  created() {
    this.warehouseId = "all";
    let stores = JSON.parse(localStorage.getItem("userInfo")).stores;
    this.storeList = [
      {
        label: this.$t('other.a1846'),
        value: "all"
      }
    ];
    stores.forEach(p => {
      if (p.isUsed) {
        this.storeList.push({
          value: p.storeId,
          label: p.storeName
        });
      }
    });

    this.init();
  },
  methods: {
    ...config,
    ...mapActions("userStoreItems", [
      "updateGroup",
      "sellerUpdateStoreItemDetail",
      "getInstockoperaterecore",
      "deleStoreItems"
    ]),


    openIsUpload() {
      this.isUpload = true
      this.getRecordDataList.pageNum = 1
      this.getRecordDataList.pageSize = 20
      this.getRecordData()
      if (this.fileData) {
        this.$nextTick(() => {
          this.$refs.uploadTEMURef.clearFiles()
          this.fileData = null
        })
      }
    },
    beforeUpload(file) {
      console.log(file)
      let extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      const isxlsx = extension === 'xlsx';

      if (!isxlsx) {
        this.$message.error('请上传后缀.xlsx的文件!');
      }
      return isxlsx;
    },
    uploadTEMU(e) {
      console.log(e)
      console.log("===-===")
      this.fileData = e.file
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.fileData = null
    },
    submitUpload() {
      if (!this.fileData || !this.exportStatus) {
        return
      }
      this.exportStatus = false;
      // return
      const loading = this.$loading({
        lock: true,
        text: '文件正在上传之中，请勿关闭页面，等待系统提示成功！',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      var formData = new FormData()
      formData.append('goodsFile', this.fileData)
      formData.append('userId', this.userId)
      galleryApi
        .batchAddGoods(formData)
        .then(res => {
          loading.close();
            this.exportStatus = true;
          console.log(res)
          if (res.code === 200) {
            this.$message.success(res.data)
            console.log("===1===")
            this.getRecordDataList.pageNum = 1
            this.getRecordDataList.pageSize = 20
            this.getRecordData()
            this.$refs.uploadTEMURef.clearFiles()
            this.fileData = null
          } else {
            this.$message.error(res.msg)
          }
        }).catch(err => {
          loading.close();
            this.exportStatus = true;
        })
    },
    getRecordData() {
      galleryApi
        .getProgress(this.userId, this.getRecordDataList.pageNum, this.getRecordDataList.pageSize)
        .then(res => {
          if (res.code === 200) {
            console.log("===1===")
            this.recordData = res.data.records
            this.getRecordDataList.total = res.data.total
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    handleSizeRecordChange(val) {
      console.log(`每页 ${val} 条`);
      localStorage.setItem('setPageSize', val)
      this.getRecordDataList.pageNum = 1
      this.getRecordDataList.pageSize = parseInt(`${val}`)
      this.getRecordData()
    },
    handleCurrentRecordChange(val) {
      this.getRecordDataList.pageNum = parseInt(`${val}`)
      this.getRecordData()
    },
    formatISODateToFull(isoString) {
      if (!isoString) {
        return
      }
      const date = new Date(isoString);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    handleStop(index, item) {
      this.$confirm('是否停止上架？停止后无法继续上架，需要重新提交表格?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        galleryApi
          .stopOrDeleteTask(this.userId, 1, item.id)
          .then(res => {
            if (res.code === 200) {
              this.$message.success(res.data)
              this.getRecordDataList.pageNum = 1
              this.getRecordDataList.pageSize = 20
              this.getRecordData()
            } else {
              this.$message.error(res.msg)
            }
          })
      })
    },
    handleDelete(index, item) {
      let text = ''
      if (item.taskStatus == 1) {
        text = '是否停止上架并删除此表格？'
      } else if (item.taskStatus == 2) {
        text = '该表格已上架完成，是否删除此记录？'
      } else {
        text = '是否删除此表格？'
      }
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        galleryApi
          .stopOrDeleteTask(this.userId, 0, item.id)
          .then(res => {
            if (res.code === 200) {
              this.getRecordDataList.pageNum = 1
              this.getRecordDataList.pageSize = 20
              this.getRecordData()
              this.$message.success(res.msg)
            } else {
              this.$message.error(res.msg)
            }
          })
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.dataParams.offset = Number(`${val}`);
      this.handleCurrentChange();
    },
    //显示当前第几页
    handleCurrentChange(val) {
      let currentPage = (parseInt(`${val}`) - 1) * this.dataParams.offset;
      this.dataParams.page = currentPage ? currentPage : 0;
      this.getdistrubureData(this.dataParams);
    },

    deleItem(item, index) {
      console.log(item);
      this.$confirm(this.$t('other.a608'), this.$t('other.a142'), {
        confirmButtonText: this.$t('other.a235'),
        cancelButtonText: this.$t('other.a146'),
        type: "warning"
      }).then(() => {
        api
          .deleteChildrenMoadel({
            productId: item.productId,
            userId: this.userId
          })
          .then(res => {
            if (res.code === 200) {
              console.log("desc", res.data);
              this.$message.success(this.$t('other.a3217'));
              this.publishFailed.splice(index, 1);
            } else {
              this.$message.warning(res.msg);
            }
          });
      });
    },

    toOpen() {
      window.open("https://erp.shopsbu.com/iddstation?userId=" + this.userId);
    },

    openGuid() {
      window.open(
        "https://www.yuque.com/docs/share/50584391-e4af-4ceb-8aca-ea171a433728?#"
      );
    },

    searchProduct() {
      console.log(this.dataParams);
      let params = JSON.parse(JSON.stringify(this.dataParams));

      params.offset = this.overDataTotal + 1;
      console.log(params);
      this.getdistrubureData(params);
    },

    init() {
      console.log(this.storeList);
      console.log(this.storeId);

      this.dataParams.storeId = null;
      this.dataParams.allUserStoreList = JSON.parse(
        localStorage.getItem("userInfo")
      ).storeIds;
      this.dataParams.isAllStore = true;
      this.getdistrubureData(this.dataParams);
    },
    showShopName(id) {
      return utils.showShopNameByshopId(id);
    },

    toDetail(item) {
      // localStorage.setItem('storeItemDetail',JSON.stringify(item))
      this.$router.push({
        path: "/saveFielf",
        query: {
          groupId: item.groupId
        }
      });
    },

    publishAgine(item) {
      console.log(item);
      this.publishFailedDia = false;
      this.$router.push({
        path: "/productModel",
        query: {
          id: this.mainProductId,
          from: "/hasAgent",
          childrenProductId: item.productId
        }
      });
    },

    discontinuedProduct(item) {
      console.log(item);
    },

    getRecord(item) {
      console.log(item);
      this.mainProductId = item.productId;
      api
        .getProductByproductId({
          productId: item.productId
        })
        .then(res => {
          if (res.code === 200) {
            console.log("desc", res.data);
            this.publishFailed = res.data.children;
            if (this.publishFailed.length > 0) {
              this.publishFailed.forEach(p => {
                if (p.productShops.length > 0) {
                  p.productShops[0].createTime = utils.getCurrnetTime(
                    p.productShops[0].createTime
                  );
                } else {
                  p.productShops = [
                    {
                      createTime: null,
                      shopId: null,
                      publishNum: 0
                    }
                  ];
                }
              });
            }
            this.publishFailedDia = true;
          } else {
            this.$message.warning(res.msg);
          }
        });
    },

    updataItem(item) {
      console.log(item);
      let params = item.storeItems.map(p => {
        return {
          value: p.cusCode,
          label: p.skuName
        };
      });

      localStorage.setItem("storeItems", JSON.stringify(params));

      if (!item.productId) {
        this.$confirm(
          this.$t("distribution.updateItemTip1"),
          this.$t("distribution.cancel"),
          {
            confirmButtonText: this.$t("distribution.updateItemTip3"),
            cancelButtonText: this.$t("distribution.tip"),
            type: "warning"
          }
        ).then(res => {
          this.$router.push({
            path: "/templateManagement",
            query: {
              flag: "bindModelFromalliance",
              groupId: item.groupId,
              storeId: item.storeId
            }
          });
        });
      } else {
        this.$router.push({
          path: "/productModel",
          query: {
            id: item.productId,
            from: "/hasAgent"
          }
        });
      }
    },

    publish(item, num) {
      console.log(item);
      let params = item.storeItems.map(p => {
        return {
          value: p.cusCode,
          label: p.skuName
        };
      });

      localStorage.setItem("storeItems", JSON.stringify(params));

      if (!item.productId) {
        this.$message.warning(this.$t('other.a2946'));
      } else {
        let router;
        if (num == 1) {
          router = this.$router.resolve({
            name: "publishShopee",
            query: {
              id: item.productId,
              groupId: item.groupId,
              from: "/hasAgent"
            }
          });
        } else if (num == 2) {
          router = this.$router.resolve({
            name: "publishLazada",
            query: {
              id: item.productId,
              groupId: item.groupId,
              from: "/hasAgent"
            }
          });
        } else if (num == 3) {
          router = this.$router.resolve({
            name: "publishTikTok",
            query: {
              id: item.productId,
              groupId: item.groupId,
              from: "/hasAgent"
            }
          });
        } else if (num == 4) {
          router = this.$router.resolve({
            name: "publishTEMU",
            query: {
              id: item.productId,
              groupId: item.groupId,
              from: "/hasAgent"
            }
          });
        }
        window.open(router.href, "_blank");
      }
    },

    getdistrubureData(params) {
      this.showLoading();
      userStoreItemsApi.getStoreItem(params).then(res => {
        if (res.code === 200) {
          console.log("分销仓数据", res.data);
          res.data.groups.forEach(p => {
            p.checked = false;
            p.allOffShelf = true;
            p.offShelfList = [];
            p.total = 0;
            p.storeItems.forEach(i => {
              p.total += i.storeNum;
              if (i.children.length > 0 && !i.children[0].putAway) {
                p.offShelfList.push(i.skuName);
              }
              if (i.children.length > 0 && i.children[0].putAway) {
                p.allOffShelf = false;
              }
            });
          });
          this.overDataList = res.data.groups;
          this.overDataTotal = res.data.count;
        }
      });
    },

    getStoreItemAndGroup(item) {
      this.warehouseId = item.value;
      if (this.warehouseId == "all") {
        this.dataParams.isAllStore = true;
        this.dataParams.allUserStoreList = JSON.parse(
          localStorage.getItem("userInfo")
        ).storeIds;
        this.dataParams.storeId = null;
      } else {
        utils.setDefalultStoreId(this.warehouseId);
        this.dataParams.storeId = this.warehouseId;
        this.dataParams.isAllStore = false;
        this.dataParams.allUserStoreList = null;
      }
      this.getdistrubureData(this.dataParams);
    },

    gotoOverseaStore() {
      this.$router.push({
        path: "/overseaProduct",
        query: {
          from: "distributeStoer",
          store: this.warehouseId
        }
      });
    },

    chooseItem(item, index) {
      let num = this.targetList.findIndex(p => p.groupId == item.groupId);
      if (num == -1) {
        this.targetList.push(item);
      } else {
        this.targetList.splice(num, 1);
      }
      console.log("num", num);
      console.log("targetList", this.targetList);
    },

    massPublishTik() {

      console.log(this.targetList);
      if (!this.targetList.length) {
        this.$message.warning(this.$t('other.a3218'))
        return;
      }
      let list = this.targetList.map(p => {
        return p.productId;
      });

      utils.updateInfoByCache({
        cacheKey: "TKS_MASS_ID",
        userId: this.userId,
        cacheData: JSON.stringify(list)
      });
      let router = this.$router.resolve({
        name: "massPublishTikTok"
      });
      window.open(router.href, "_blank");
    },

    massDeletd() {
      let desc =
        this.$t('other.a3219') +
        this.targetListCopy.length +
        this.$t('other.a3220');
      this.$confirm(desc, this.$t("distribution.tip"), {
        confirmButtonText: this.$t("distribution.determine"),
        cancelButtonText: this.$t("distribution.cancel"),
        type: "warning"
      }).then(() => {
        userStoreItemsApi.deleteGroup(this.targetListCopy).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t("distribution.deleteSuccess"));
            this.getdistrubureData(this.dataParams);
            this.targetList = [];
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    }

    // //控制每页显示订单条数
    // handleSizeChangeTwo(val) {
    //   console.log(`每页 ${val} 条`);
    //   this.offset = parseInt(`${val}`);
    //   this.getDataList.offset = parseInt(`${val}`);
    //   this.handleCurrentChange();
    // },
    // //显示当前第几页
    // handleCurrentChangeTwo(val) {
    //   console.log(`${val}`);
    //   this.resetPage();
    //   this.currentPage = parseInt(`${val}`);
    //   let ppg =
    //     `${val}` == "undefined" ? 0 : (parseInt(`${val}`) - 1) * this.offset;
    //   this.getDataList.page = ppg;
    //   this.getStoreItemAndGroup();
    // },
  }
};
</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";

.myself_wrapper {
  background-color: #eee;

  .jkgiong {
    margin-right: 30px;
  }

  .ifnk {
    display: inline-block;
    width: 15px;
    border-radius: 2px;
    height: 15px;
    background-color: aquamarine;
    margin-right: 5px;
  }

  .ifnkCopy {
    display: inline-block;
    width: 15px;
    height: 15px;
    border-radius: 2px;
    background-color: red;
    margin-right: 5px;
  }

  .Pager {
    position: fixed;
    bottom: 0;
    left: 205px;
    right: 0;
    height: 40px;
    line-height: 40px;
    background-color: #fff;
    text-align: right;
    padding: 0 20px;
  }

  .overseaProduct_list {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 50px;

    .overseaProduct_item {
      box-sizing: border-box;
      margin: 8px 5px;
      background-color: #fff;
      border-radius: 5px;
      border: 1px solid #fff;
    }

    .overseaProduct_item_active {
      border: 1px solid #f56c6c;
    }

    .update_overseaProduct {
      display: flex;
      justify-content: space-between;
      text-align: right;
      margin: 7px 0;

      .bitbn {
        border-radius: 3px;
        padding: 4px 5px;
        color: #409eff;
        font-size: 12px;
        font-weight: bold;
        cursor: pointer;
      }

      .btn {
        background-color: #f56c6c;
        border-radius: 3px;
        padding: 4px 5px;
        color: #eee;
        font-size: 12px;
        font-weight: bold;
        cursor: pointer;
      }

      .btn_reverse {
        background-color: #909399;
        border-radius: 3px;
        padding: 4px 5px;
        color: #eee;
        font-size: 12px;
        font-weight: bold;
        cursor: pointer;
      }
    }

    .pic_box {
      width: 150px;
      height: 150px;
      overflow: hidden;
      border-radius: 5px;
      position: relative;

      .offshelf {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 90%;
        height: 90%;
        text-align: center;
        line-height: 160%;
        background-color: rgb(46, 45, 45);
        opacity: 0.7;
        border-radius: 50%;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        color: #fff;
        font-size: 20px;
      }
    }

    .title_overseaProduct {
      width: 148px;
      height: 1.7rem;
      -webkit-line-clamp: 2;
      text-overflow: ellipsis;
      overflow: hidden;
      padding: 2px;
      font-size: 12px;
    }

    .item_desc {
      width: 148px;
      height: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
      padding: 5px 0;
    }

    .item_desc_parentsku {
      color: #f56c6c;
      width: 148px;
      height: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
      padding: 5px 0;
    }
  }

  /deep/ .el-checkbox__inner {
    width: 20px;
    height: 20px;
  }

  /deep/ .el-checkbox__inner::after {
    height: 10px;
    left: 7px;
    width: 4px;
    font-weight: bold;
  }

  .header_top {
    .ijkgn {
      font-size: 22px;
      font-weight: bold;
      padding: 10px 0;
      color: #757575;
    }

    width: 100%;
    // margin-top: 106px;
    background-color: #fff;
    z-index: 9;
    border-bottom: 1px solid #eee;

    .query-list-tcp {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px 0 8px 0;
    }

    .query_list {
      padding: 10px 0 15px 0;
      flex-wrap: wrap;
      @include flex-start();

      .item_wrapper {
        min-width: 80px;
        display: inline-block;
        box-shadow: 0 1px 6px 0 #eee;
        border-radius: 8px;
        margin-right: 10px;
        box-sizing: border-box;
        padding: 10px;
        cursor: pointer;
        font-size: 20px;
        margin-bottom: 10px;
      }

      .item_active {
        color: #fff;
        background-color: #409eff;
      }
    }
  }

  .goodsArea {
    margin-top: 237px;
    margin-bottom: 120px;
  }

  .list-item {
    padding: 0 20px 0 0;
    margin-bottom: 10px;
    background-color: #fff;
    box-sizing: border-box;
    margin: 5px 10px;
    padding: 10px;

    .childrenItem {
      padding: 10px 0 5px 25px;
      border-bottom: 1px solid #eee;

      .goods-title-desc-wrapper {
        @include flex-between();

        .check_And_Img {
          display: flex;
        }
      }
    }

    .outPsku {
      @include flex-between();
      align-items: center;

      .outPsku_left {
        display: flex;
        align-items: center;

        .el-input {
          width: 300px;
        }

        .el-icon-edit {
          margin-left: 15px;
          cursor: pointer;
          color: #409eff;
          font-size: 18px;
        }
      }

      .outPsku_right {
        display: flex;
        align-items: center;
      }
    }

    .btn-item-desc {
      padding: 0 0 8px 0;
    }

    .outDesc {
      @include flex-between();

      .goods-pic {
        width: 80px;
        height: 80px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

.stepsBox {
  padding: 0px 10px;

  .stepsItem {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    border-left: 1px solid #dcdcdc;

    .stepsIndex {
      position: absolute;
      left: -14px;
      width: 20px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background: #ff8000;
      color: #fff;
      top: -4px;
      border: 4px solid #fff;
    }

    .stepsTitle {
      width: 100%;
      padding-left: 20px;
      font-weight: bold;
      font-size: 16px;
    }

    .stepsContent {
      width: 100%;
      padding: 20px;

      .tips {
        color: red;
      }
    }
  }
}

.recordBox {
  margin-top: 20px;

  .recordTitle {
    width: 100%;
    padding-left: 10px;
    font-weight: bold;
    font-size: 16px;
    border-left: 2px solid #ff8000;
    margin-bottom: 10px;
  }

  .recordItem {
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    border-bottom: 1px solid #dcdcdc;
    margin-bottom: 10px;

    .time {
      color: #999;
    }
  }
}
</style>